// Add your custom JS here.


 jQuery(document).ready(function($) {


    // Function to trigger preloader
    $.fn.triggerPreloader = function() {
        var loaderDuration = 550; // Time to show preloader

        // Preloader fade out and page fade in logic
        setTimeout(function() {
            $('#preloader').fadeOut('slow', function() {
                $('#page').fadeIn(250); // Fade in the page after the preloader fades out
            });
        }, loaderDuration);
    }


    // Preloader logic only on initial page load
    $.fn.triggerPreloader();

    // Disable preloader for Gravity Forms interactions
    $(document).on('click', '.gform_page_footer input[type="button"], .gform_next_button', function() {

        // This will execute whenever Gravity Forms changes pages or renders new forms
        $('#preloader').hide(); // Ensure preloader is hidden
        console.log('hide_preloader');
        $('#page').show(); // Ensure page content is shown
    });



    /* Gravity Forms */
    // Listener for label clicks
    // Form behaviour in AJAX mode
    
    $('.bootstrap-radio-buttons label').click(function(event) {

        // // Check if the clicked label is for the configurator anchor
        if ($(this).attr('for') === 'configurator') {
            event.preventDefault(); // Prevent the default action of the configurator anchor
            return; // Exit the function to ignore the click
        }

        var inputId = $(this).attr('for');
        $('#' + inputId).prop('checked', true).trigger('change');
    });



    $(document).on('change', '.bootstrap-radio-buttons input[type="radio"]', function() {
        // Remove 'active' class from all labels within the same form
        $(this).closest('.bootstrap-radio-buttons').find('label').removeClass('active');
    
        // Check if the changed radio button is selected and apply 'active' class to the corresponding label
        if ($(this).is(':checked')) {
            $('label[for="' + $(this).attr('id') + '"]').addClass('active');
        }
    });
    
    // Ensure active class is applied correctly when moving back and forth in multi-page forms
    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
        // Re-apply active class based on checked state after a new page of the form is loaded
        $('.bootstrap-radio-buttons input[type="radio"]:checked').each(function() {
            $('label[for="' + $(this).attr('id') + '"]').addClass('active');
        });
    });
    


    // Assuming your form has a specific ID
    var form = $('.joltion_configurator'); // Replace '1' with your actual form ID
    var summaryField = $('#thejoltionsummary'); // Replace '1_10' with the ID of your HTML field

    function updateSummary() {
      
        var summary = "<div class='table-responsive'><table class='table table-striped'>";
        summary += "<th width='75%'>Onze vraag</th><th width='25%'>Jouw antwoord</th>";
       

       // Handling radio buttons and checkboxes
        form.find('input[type="radio"]:checked, input[type="checkbox"]:checked').each(function() {
            var label = $(this).closest('.gfield').find('legend.gfield_label').text();
            label = label.replace(' (Vereist)', '').replace('(Vereist) ', '').replace('(Vereist)', '');
            var value = $(this).next('label').text();
            summary += "<tr><td>" + label + "</td><td>" + value + "</td></tr>";
            console.log("Adding to summary:", label, value);

        });

        summary += "</table></div>";

        
        // Update the HTML field with the summary
        summaryField.html(summary);
    }

    // Attach change event to all relevant fields to update the summary as user fills out the form
    form.find('input, textarea, select').change(updateSummary);

    // Initial summary update
    updateSummary();




    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
        console.log('Form page loaded:', form_id, 'Page:', current_page);
        form = $('.joltion_configurator');  // Re-select the form to update the jQuery object
        $('.gform_ajax_spinner').wrap('<div id="spinner-overlay" style="display:none;"></div>');

            if(current_page == 9 || current_page == 10){
                console.log('arrived!');
                $('#summarycontainer').show();
            }else{
                $('#summarycontainer').hide();
            }
        
            


        updateSummary();
    });
    

    // Handle quantity increment and decrement
    $('.quantity-container').each(function() {
        var $container = $(this);
        var $input = $container.find('.qty');

        $container.find('.quantity-decrease').on('click', function() {
            var currentValue = parseInt($input.val());
            if (currentValue > 1) {
                $input.val(currentValue - 1);
            }
        });

        $container.find('.quantity-increase').on('click', function() {
            var max = parseInt($input.attr('max'));
            var currentValue = parseInt($input.val());
            if (isNaN(max) || currentValue < max) {
                $input.val(currentValue + 1);
            }
        });
    });



    $(document).on('added_to_cart', function(event, fragments, cart_hash, $button) {
        // Change the button's background color and icon
        $button.addClass('added').css('background-color', '#800080'); // Example purple color
        $button.find('i.fa').removeClass('fa-cart-plus').addClass('fa-check'); // Change icon

        // Show the 'Bekijk winkelwagen' link if not already visible
        $('.added_to_cart').hide();
    });


    $(document).on('click', '.add_to_cart_button', function(e) {
        e.preventDefault();
        var $form = $(this).closest('form');
        var data = $form.serialize(); // This should include the quantity input
        $.ajax({
            url: $form.attr('action'),
            method: 'POST',
            data: data,
            success: function(response) {
                console.log('Product added:', response);
                // Handle additional UI updates or redirections here
            },
            error: function() {
                console.error('Failed to add the product');
            }
        });
    });
    
    $('form.cart').on('submit', function(e) {
        e.preventDefault();

        var formData = $(this).serialize(); // This captures all the form data

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: formData, // This should now include both product_id and quantity
            success: function(response) {
                console.log('Product added:', response);
                if (!response.error && response.fragments) {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, null]);
                }
            },
            error: function() {
                console.error('Error adding product to cart');
            }
        });
    });

});
